import React from "react";

const MastercardVisaIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    width="40"
    height="29"
    viewBox="0 0 40 29"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <rect
      x="0.0273438"
      y="0.0703125"
      width="39.9089"
      height="28"
      rx="4"
      fill="#CB3CFF"
    />
    <path
      d="M17.6371 18.8247H15.1914L16.7211 9.34558H19.1667L17.6371 18.8247Z"
      fill="white"
    />
    <path
      d="M26.5005 9.57739C26.0181 9.3856 25.253 9.17383 24.3069 9.17383C21.8917 9.17383 20.1909 10.4645 20.1805 12.3099C20.1604 13.6713 21.3982 14.4275 22.3239 14.8815C23.2702 15.3454 23.5918 15.6482 23.5918 16.0616C23.5822 16.6967 22.8272 16.9894 22.1231 16.9894C21.1466 16.9894 20.6234 16.8385 19.8284 16.4852L19.5063 16.3337L19.1641 18.4616C19.7377 18.7235 20.7945 18.9559 21.8917 18.9661C24.4579 18.9661 26.1286 17.6953 26.1484 15.7288C26.1581 14.6498 25.5046 13.8229 24.0955 13.1473C23.2401 12.7136 22.7162 12.4211 22.7162 11.9773C22.7262 11.5739 23.1593 11.1607 24.1249 11.1607C24.92 11.1405 25.5042 11.332 25.9467 11.5236L26.1679 11.6243L26.5005 9.57739Z"
      fill="white"
    />
    <path
      d="M29.7527 15.4666C29.9541 14.922 30.7291 12.8144 30.7291 12.8144C30.7189 12.8347 30.9301 12.2598 31.0509 11.9069L31.2218 12.7237C31.2218 12.7237 31.6849 14.9927 31.7855 15.4666C31.4033 15.4666 30.2357 15.4666 29.7527 15.4666ZM32.7716 9.34558H30.8798C30.2964 9.34558 29.8532 9.51687 29.6015 10.1321L25.9688 18.8246H28.535C28.535 18.8246 28.9574 17.6546 29.0483 17.4027C29.3298 17.4027 31.8262 17.4027 32.1883 17.4027C32.2586 17.7355 32.4802 18.8246 32.4802 18.8246H34.7446L32.7716 9.34558Z"
      fill="white"
    />
    <path
      d="M13.1476 9.34558L10.7525 15.8095L10.4907 14.4985C10.0479 12.9858 8.65916 11.3424 7.10938 10.5252L9.30325 18.8147H11.8895L15.7337 9.34558H13.1476Z"
      fill="white"
    />
    <path
      d="M8.52789 9.34558H4.59299L4.55273 9.53713C7.62221 10.3238 9.65506 12.2202 10.4903 14.4995L9.63486 10.1425C9.49403 9.537 9.06125 9.36555 8.52789 9.34558Z"
      fill="white"
    />
  </svg>
);

export default MastercardVisaIcon;
